import React from 'react';

export const getAgenciesColumns = (dealersList, provincesList) => {
  return [
    {
      'Header': 'CONCESIONARIO',
      'accessor': 'identification',
      'width': '3',
      'Filter': ({
        'column': {filterValue, setFilter},
      }) => {
        return (
          <select style={{'height': '26px', 'min-height': '0', 'padding': '0 1em'}}
            class="ui fluid search selection dropdown compact"
            value={filterValue}
            onChange={(e) => {
              setFilter(e.target.value || null);
            }}
          >
            <option className='item' value="">TODOS</option>
            {dealersList.map((dealer, i) => (
              <option className='item' key={i} value={dealer.identification}>
                {dealer.name}
              </option>
            ))}
          </select>
        );
      },
    },
    {
      'Header': 'RUC',
      'accessor': 'ruc',
      'width': '2',
    },
    {
      'Header': 'AGENCIA',
      'accessor': 'code',
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'name',
      'width': '2',
    },
    {
      'Header': 'TRANS.',
      'accessor': 'driverArray',
      'Filter': () => {
        return null;
      },
    },
    {
      'Header': 'DIRECCIÓN',
      'accessor': 'address',
      'width': '4',
    },
    {
      'Header': 'PROVINCIA',
      'accessor': 'provinceCode',
      'width': '2',
      'Filter': ({
        'column': {filterValue, setFilter},
      }) => {
        return (
          <select style={{'height': '26px', 'min-height': '0', 'padding': '0 1em'}}
            class="ui fluid search selection dropdown compact"
            value={filterValue}
            onChange={(e) => {
              setFilter(e.target.value || null);
            }}
          >
            <option className='item' value="">TODOS</option>
            {provincesList.map((province, i) => (
              <option className='item' key={i} value={province.code}>
                {province.name}
              </option>
            ))}
          </select>
        );
      },
    },
    {
      'Header': 'CIUDAD',
      'accessor': 'cantonCode',
      'width': '3',
      'Filter': ({
        'column': {filterValue, setFilter},
      }) => {
        return (
          <select style={{'height': '26px', 'min-height': '0', 'padding': '0 1em'}}
            class="ui fluid search selection dropdown compact"
            value={filterValue}
            onChange={(e) => {
              setFilter(e.target.value || null);
            }}
          >
            <option className='item' value="">TODOS</option>
            {provincesList.map((province, i) => (
              province.array_canton.map((canton) => (
                <option className='item' key={i} value={canton.cantonCode}>
                  {canton.cantonName}
                </option>
              ))
            ))}
          </select>
        );
      },
    },
    {
      'Header': 'TELEFONO',
      'accessor': 'phone',
      'width': '1',
    },
    /* {
      'Header': 'TIPO',
      'accessor': 'phone',
      'width': '1',
    }, */
    {
      'Header': 'ESTADO',
      'accessor': 'status',
      'Filter': () => {
        return null;
      },
    },
    /* {
      'Header': 'C REF',
      'accessor': 'phone',
      'width': '1',
    },
    {
      'Header': 'VEH',
      'accessor': 'phone',
      'width': '1',
    },
    {
      'Header': 'SEC. EMER',
      'accessor': 'phone',
      'width': '1',
    },
    {
      'Header': 'SEC. STK',
      'accessor': 'phone',
      'width': '1',
    },
    {
      'Header': 'SEK. ESP',
      'accessor': 'phone',
      'width': '1',
    }, */
  ];
};
